import { titleCaseKey } from "@/lib/aiPlanUtils";

/**
 * v1.3 Wave 2 — renders any plan's `metrics` / `changes_preview` /
 * `execution_result` counts object as a compact grid of chips. Works
 * uniformly across all plan kinds (sick_day, weather_cancellation,
 * draft_communication, reschedule_single) since each just carries a
 * flat object of label to count, so no per-kind branching is needed here.
 */
export const PlanChangeSummaryList = ({ counts, testIdPrefix = "ai-action-plan-summary" }) => {
  const entries = Object.entries(counts || {}).filter(([, v]) => v !== null && v !== undefined && typeof v !== "object");
  if (entries.length === 0) return null;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testIdPrefix}-list`}>
      {entries.map(([key, value]) => (
        <div key={key} className="rounded-lg border bg-[hsl(var(--secondary))] px-2 py-1" data-testid={`${testIdPrefix}-${key}`}>
          <div className="text-[11px] text-muted-foreground leading-tight">{titleCaseKey(key)}</div>
          <div className="mt-0.5 font-mono-ui text-xs font-semibold">{String(value)}</div>
        </div>
      ))}
    </div>
  );
};
